// DS9.4.3, DS9.4.3M
import React from 'react';
import { getIsShortStatus } from '../../_helpers';
import FeedCardLayout from '../_partials/FeedCardLayout';
import { FeedCardProps } from '../types';
import StatusTierPaywall from './StatusTierPaywall';
import ShortStatus from './ShortStatus';
import LongStatus from './LongStatus';

const StatusFeedCardContents: React.FC<FeedCardProps> = props => {
  const { className, deviation, extraActions, withWatchOrSubscribeButton } = props;
  const isShortStatus = getIsShortStatus(deviation);
  return (
    <FeedCardLayout
      className={className}
      deviation={deviation}
      extraActions={extraActions}
      isExpandable={!isShortStatus}
      withWatchOrSubscribeButton={withWatchOrSubscribeButton}
      withCommentControl
      withFaveControl
    >
      <StatusTierPaywall deviation={deviation}>
        {isShortStatus ? <ShortStatus {...props} /> : <LongStatus {...props} />}
      </StatusTierPaywall>
    </FeedCardLayout>
  );
};
StatusFeedCardContents.displayName = 'StatusFeedCardContents';
export default StatusFeedCardContents;
